import { createApp } from 'vue'
import App from './App.vue'
import Router from './router/router.config'
import ElementPlus from "element-plus"
import '../node_modules/element-plus/dist/index.css'
import './style/css-vars.less'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
// import TlbsMap from 'tlbs-map-vue';
import {createPinia} from 'pinia'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const pinia = createPinia()
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app
.use(ElementPlus,{
    locale:zhCn
})
// .use(TlbsMap)
.use(pinia)
.use(Router)

app.mount('#app')
